//const ROOTURL = "http://localhost:8000/api/v1"
const ROOTURL = "https://api.gofinito.com/api/v1"
export default ROOTURL

export const BUSINESSID = "6afea9e3-3cfe-4c11-be30-ec637534b0f5"

export const BLOCATIONID = "1d98ff4c-1035-410d-80c3-1b4beb55b397"
